import type { VehicleType } from '@sravni/cosago-react-library/lib/types';

import { VEHICLE_TEXT_MAP_GENITIVE_CASE } from 'shared/config/vehicleTypeText';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';

export const PledgeAutoFormFieldsTexts = (vehicleType: VehicleType): Record<keyof TPledgeAutoFields, string> => ({
  enginePower: 'Мощность двигателя',
  carBrand: 'Марка',
  carManufactureYear: 'Год выпуска',
  carModel: 'Модель',
  carNumber: `Номер ${VEHICLE_TEXT_MAP_GENITIVE_CASE[vehicleType]}`,
  isTaxi: '',
  isOwner: 'Я владелец автомобиля',
});
